import React, { useEffect, useState } from 'react'
import img from '../../assets/team.svg'
import axios from 'axios'
import { toast, Toaster } from 'sonner'

const JoinTeam = () => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const [formsubmitted, setFormSubmitted] = useState(false)

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [message, setmessage] = useState("");

  const [cvFile, setCvFile] = useState(null); // State to store the CV file


  const handleSubmit = async () => {

    if (!fullName || !email || !phone || !linkedin || !message || !cvFile) {
      toast.error('Please fill all required details')
      return
    }

    try {
      const formData = new FormData();
      formData.append('name', fullName);
      formData.append('email', email);
      formData.append('phone', phone);
      formData.append('linkedin', linkedin);
      formData.append('message', message);
      if (cvFile) {
        formData.append('cv', cvFile); // Append the CV file
      }

      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/jobs/jointeam`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data' // Important for file uploads
        }
      });

      console.log('Application submitted:', response);

      if (response.data.success) {
        setFormSubmitted(true);
        // setIsApplySubmitModalOpen(true);
      }

    } catch (error) {
      console.error('Error submitting application:', error);
    }
  };

  return (
    <div className='bigscreen p-16'>

      <div className='flex justify-between items-center gap-10'>
        <div className='w-full'>
          <div className='text-4xl font-bold'>
            We are Always Looking for Fresh Talent!
          </div>
          <div className='text- medium text-sm max-w-[560px] mt-10'>
            At Hunt High, we believe in talent over timing. We are always on the lookout for passionate, curious, and creative minds ready to innovate and make a difference. We are building a community of innovators and problem-solvers. While we may not have current job openings, we’re always excited to connect with passionate individuals ready to make an impact.
          </div>
          <div className='text-medium text-sm max-w-[560px] mt-2'>
            Think you’d be a great fit for our team? Share your CV or portfolio with us at <span className='font-semibold'>admin@hunthigh.in</span>, and let’s explore how we can work together to shape the future of business innovation.
          </div>

          {/* <button className='button text-sm mt-6'>
            Submit Your Resume
          </button> */}
        </div>

        <div className='w-full'>
          <img src={img} className='h-full w-full object-contain' />
        </div>
      </div>


      {formsubmitted ?
        <div className='mt-20 w-full max-w-[900px] bg-white rounded-[32px] shadow py-14 px-8 flex flex-col gap-6 mx-auto'>
          <div>
            <h3 className="text-xl font-bold text-gray-900">Thank you for your application to join our team!</h3>
            <p className="text-sm text-gray-500 border-b pb-3 mt-6">Your details have been successfully submitted.
              <br /> We’ll notify you on your email soon.</p>
          </div>
        </div>
        :

        <div className='mt-20 w-full max-w-[900px] bg-white rounded-[32px] shadow py-6 px-8 flex flex-col gap-6 mx-auto'>

          <div>
            <h3 className="text-xl font-bold text-gray-900">Join The Hunt High Team</h3>
            <p className="text-sm text-gray-500 border-b pb-3">Complete the following details</p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Full Name
            </label>
            <input
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              className="input w-full mt-2"
              placeholder="Enter your full name"
            />
          </div>

          {/* Email Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input w-full mt-2"
              placeholder="Enter your email"
            />
          </div>

          {/* Current Location Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Phone Number
            </label>
            <input
              type="text"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="input w-full mt-2"
              placeholder="Enter your Phone Number along with Country Code"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Linkedin URL
            </label>
            <input
              type="text"
              value={linkedin}
              onChange={(e) => setLinkedin(e.target.value)}
              className="input w-full mt-2"
              placeholder="Enter your linkedin URL"
            />
          </div>

          <label htmlFor="cvUpload" className="group relative flex items-center justify-center rounded-md border border-dashed border-gray-300 py-3 px-4 text-center cursor-pointer hover:border-blue-500 transition-colors duration-300">
            <div className="space-y-1 text-center">
              <svg
                className="mx-auto h-12 w-12 text-gray-400 group-hover:text-blue-500 transition-colors duration-300"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 48 48"
                aria-hidden="true"
              >
                <path
                  d="M28 8H12a4 4 0 0-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4V12a4 4 0 014-4h16m-8 0L24 3l4 5m-4 15v7m-8-7h16"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div className="flex text-sm text-gray-600">
                {cvFile ?
                  <>
                    <span className="font-medium text-orange-500 group-hover:text-orange-600 transition-colors duration-300">
                      {cvFile.name}
                    </span>
                    <p className="pl-1">File Uploaded</p>
                  </>
                  : <>
                    <span className="font-medium text-blue-500 group-hover:text-blue-600 transition-colors duration-300">
                      Upload your CV
                    </span>
                    <p className="pl-1">or drag and drop</p>
                  </>
                }
              </div>
              <p className="text-xs text-gray-500">PDF, DOC, DOCX</p>
            </div>
            <input
              type="file"
              id="cvUpload"
              accept=".pdf,.doc,.docx"
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              onChange={(e) => {
                if (e.target.files && e.target.files[0]) {
                  console.log("CV uploaded:", e.target.files[0]);
                  // Store the file in state or perform other actions
                  // Example:
                  setCvFile(e.target.files[0]);
                  const file = e.target.files[0];
                  // You can now use the 'file' variable
                  // for further processing, such as uploading.
                }
              }}
            />
          </label>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Message
            </label>
            <textarea
              type="text"
              value={message}
              onChange={(e) => setmessage(e.target.value)}
              className="input w-full mt-2"
              placeholder="Enter your message"
            />
          </div>
          <button onClick={handleSubmit} className="button w-40 mx-auto">
            Submit
          </button>
        </div>

      }
      <Toaster richColors position='bottom-center' />
    </div>
  )
}

export default JoinTeam